import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

// This template inside the commissionReport url is replaced with the producer code
const PRODUCER_CODE_TEMPLATE = '%%PRODUCER-CODE%%';

const fn = ($state, $scope, $rootScope, UserService, $injector) => {
    const ctrl = Object.create(BaseCtrl);

    let commissionReports = [];
    const CONFIGURATION_PROVIDER = 'COMMISSIONS';
    if ($injector.has(CONFIGURATION_PROVIDER)) {
        // Only load the configuration in portals that provide it
        commissionReports = $injector.get(CONFIGURATION_PROVIDER);
    }

    if (!Array.isArray(commissionReports) || commissionReports.length === 0) {
        return;
    }

    $scope.selectStatement = (statement) => {
        $scope.selectedStatement = statement;
    };

    $scope.isStatementSelected = (statement) => $scope.selectedStatement === statement;

    $scope.statements = [
        {
            key: '1',
            title: 'January',
            subtext: 'sub text Jan',
            info: 'Info for Jan'
        },
        {
            key: '2',
            title: 'January2',
            subtext: 'subtext Jan2',
            info: ''
        },
        {
            key: '3',
            title: 'January3',
            subtext: '',
            info: 'Info for Jan3'
        },
        {
            key: '4',
            title: '',
            subtext: 'subtext Jan4',
            info: 'Info for Jan4'
        },
        {
            key: '5',
            title: '',
            subtext: '',
            info: ''
        },
        {
            key: '6',
            title: 'January6',
            subtext: '',
            info: ''
        },
        {
            key: '7',
            title: '',
            subtext: '',
            info: 'Info for Jan7'
        },
        {
            key: '8',
            title: '',
            subtext: 'subtext Feb',
            info: ''
        }
    ];

    $scope.selectedStatement = $scope.statements[0];

    $scope.producerCode = {
        code: ''
    }; // Initial value

    $scope.select = (commissionReport) => {
        commissionReports.forEach((_commissionReport) => {
            _commissionReport.active = false;
        });
        commissionReport.active = true;
        const producerCode = $scope.producerCode.code === 'all' ? '' : $scope.producerCode.code;
        $scope.commissionReportType = commissionReport.type;

        if ($scope.commissionReportType === 'commissionsToDate') {
            $scope.commissionReportUrl = commissionReport.commissionReportUrl !== null ? commissionReport.commissionReportUrl.replace(PRODUCER_CODE_TEMPLATE, encodeURIComponent(producerCode)) : null;
        } else if ($scope.commissionReportType === 'statements') {
            $scope.commissionReportUrl = commissionReport.commissionReportUrl;
        }
        $scope.isCommissionsReportEnabled = commissionReport.enabled && commissionReport.type === 'commissions';
    };
    $scope.select(commissionReports[0]);

    $scope.updateSelected = () => $scope.select(_.find(commissionReports, 'active'));

    $scope.$watch(() => $rootScope.selectedProducerCode, newVal => {
        // during the first digest cycle newVal is undefined so we avoid resetting the
        // previous assignment for $scope.producerCode
        $scope.producerCode = newVal || $scope.producerCode;
    });
    $scope.$watch('producerCode', $scope.updateSelected);

    if (commissionReports.length > 1) {
        // Only render tiles if there's a choice of commissionReports
        $scope.commissionReports = commissionReports;
    }

    return ctrl.create($scope);
};
fn.$inject = ['$state', '$scope', '$rootScope', 'UserService', '$injector'];

export default fn;